import { createAction, props } from '@ngrx/store';
import { TeamMember } from '@shared';
import { SharedResourcesType } from '@core/shared-resources/shared-resources.model';

export const sharedResourcesUpdateCurrent = createAction(
  '[Shared Resources] Update Current',
  props<{
    resourceId?: number;
    resourceType?: SharedResourcesType;
    teamMembers?: TeamMember[];
  }>(),
);
export const sharedResourcesStoreRemoveFromCurrent = createAction(
  '[Shared Resources] Remove Team Member From Stored Current Resource',
  props<{ memberId: number }>(),
);

export const sharedResourcesStoreCurrent = createAction(
  '[Shared Resources] Store Current',
  props<{ resourceId?: number; resourceType: SharedResourcesType; teamMembers: TeamMember[] }>(),
);
